import { CAMPAIGN_SORT } from '@/entities/campaign';
import { SearchInput } from '@/shared/components/search-input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/shadcn/select';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/shadcn/tabs';
import type { CampaignListFilter } from '../../hooks';
import { statusConfigs } from '../campaign-detail/detail-constants';

const sortOptions: Array<{
  value: CAMPAIGN_SORT;
  label: string;
}> = [
  { value: CAMPAIGN_SORT.START_DATE_DESC, label: 'Start date' },
  { value: CAMPAIGN_SORT.ENDING_DATE, label: 'Ending date' },
];

export function CampaignStatusTabs({
  selectedFilter,
  onSelect,
}: {
  selectedFilter: CampaignListFilter;
  onSelect: (nextFilter: CampaignListFilter) => void;
}) {
  return (
    <Tabs value={selectedFilter} onValueChange={(value) => onSelect(value as CampaignListFilter)}>
      <TabsList className="grid w-full max-w-105 grid-cols-4">
        {statusConfigs.toArray().map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key}>
            {tab.value.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}

export function SearchToolbar({
  searchQuery,
  onSearchQueryChange,
}: {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
}) {
  return (
    <SearchInput
      className="max-w-55"
      initialValue={searchQuery}
      onClear={() => onSearchQueryChange('')}
      onSubmit={onSearchQueryChange}
      placeholder="Search campaigns"
    />
  );
}

export function SortControl({
  sortOption,
  onSortOptionChange,
}: {
  sortOption: CAMPAIGN_SORT;
  onSortOptionChange: (value: CAMPAIGN_SORT) => void;
}) {
  return (
    <Select
      value={sortOption}
      onValueChange={(value) => onSortOptionChange(value as CAMPAIGN_SORT)}
    >
      <SelectTrigger className="w-fit min-w-40">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
